import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import { CheckPermission } from 'modules/login/CheckPermission';
import { ShowIf } from 'components/utils';
import {get} from 'lodash';
import {ChiTietDoiTuongThanhTraDialog} from 'modules/dialog';

class RowItemDanhSachTheoDoiThucHien extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chiTietDT: false
    }
  }

  toggleDialog(status) {
    this.setState({chiTietDT: status});
  }

    render() {
      let Data = this.props.item || {};
      let tenCuocThanhTra = '';
      if (Data && Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
        tenCuocThanhTra = Data.listDoiTuongThanhTra[0].ten;
      } else if (Data && Data.tenNhieuDoiTuongThanhTra) {
        tenCuocThanhTra = Data.tenNhieuDoiTuongThanhTra;
      }
    return (
      <tr>
        <td>{this.props.count}</td>
        <td className='list-items-table'>
          <ul className="list-items-table">
            <li>
              <Link className='txt-underline txt-regular' onClick={this.toggleDialog.bind(this, true)}>{this.props.item.ten}</Link>
              <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={this.props.item} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this, false)} />
            </li>
            <li>{get(Data, 'listDoiTuongThanhTra.length')} đối tượng</li>
          </ul>
        </td>
        <td>
          <Link className='txt-underline txt-regular' to={`/theo-doi-thuc-hien/chi-tiet/${get(Data, 'cuocThanhTraId')}`}>{get(Data, 'noiDungThanhTra')}</Link>
        </td>
        <td>
        <ul className="list-items-table">
            <li>{get(Data, 'hinhThucThanhTraInfo.text')}</li>
            <li>{get(Data, 'loaiHinhThanhTraInfo.text')}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{get(Data, 'soQuyetDinhVeViecThanhTra')}</li>
            <li>{this.props.item.ngayRaQuyetDinh ? moment(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''}</li>
          </ul>
        </td>
        <td>{this.props.item.ngayChuyenTheoDoiThucHien ? moment(this.props.item.ngayChuyenTheoDoiThucHien).format('DD/MM/YYYY') : ''}</td>
        <td>{this.props.item.soKetLuanThanhTra ? this.props.item.soKetLuanThanhTra : ''}</td>
        <td>{this.props.item.tienDoThanhTraInfo ? this.props.item.tienDoThanhTraInfo.text : ''}</td>
        <td>
          <ShowIf condition={(CheckPermission('THEO_DOI_THUC_HIEN_SUA') || CheckPermission('THEO_DOI_THUC_HIEN_LIETKE')) && get(Data, 'tienDoThanhTra') !== 'LUU_HO_SO'}>
            <div className="todo-wrap two-item">
              <Link className="itt-redirect" to={`/theo-doi-thuc-hien/xu-ly/${get(Data, 'cuocThanhTraId')}`}>Xử lý</Link>
            </div>
          </ShowIf>
        </td>
      </tr>
    );
  }
}


export default RowItemDanhSachTheoDoiThucHien;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/datatable/RowItemDanhSachTheoDoiThucHien.jsx